const exponentCache = new Map();
function minorExponent(currency) {
    const code = (currency || 'USD').toUpperCase();
    const cached = exponentCache.get(code);
    if (cached !== undefined)
        return cached;
    let exp = 2;
    try {
        const opts = new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).resolvedOptions();
        if (typeof opts.maximumFractionDigits === 'number')
            exp = opts.maximumFractionDigits;
    }
    catch {
        exp = 2;
    }
    exponentCache.set(code, exp);
    return exp;
}
/** Formats integer minor units as a localized currency string. */
export function formatMoneyLocale(minor, currency, locale) {
    const exp = minorExponent(currency);
    const major = minor / 10 ** exp;
    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency || 'USD',
        }).format(major);
    }
    catch {
        return `${major.toFixed(exp)} ${currency}`;
    }
}
/** Formats a Unix timestamp (seconds) as a localized date/time string. */
export function formatDateLocale(unixSec, locale) {
    return new Intl.DateTimeFormat(locale, {
        dateStyle: 'medium',
        timeStyle: 'short',
    }).format(new Date(unixSec * 1000));
}
/** Formats a number with locale-aware grouping and decimal separators. */
export function formatNumberLocale(value, locale, options) {
    return new Intl.NumberFormat(locale, options).format(value);
}
//# sourceMappingURL=format.js.map